import { ElMessage } from "element-plus";

/**
 * @description: 校验网络请求状态码
 * @param {Number} status
 * @return void
 */
export const checkStatus = (status: number): void => {
	switch (status) {
		case 400:
			ElMessage.error("The request failed! Please try again later");
			break;
		case 401:
			ElMessage.error("Login invalid! Please log in again");
			break;
		case 403:
			ElMessage.error("The current account has no permission to access!");
			break;
		case 404:
			ElMessage.error("The resource you are accessing does not exist!");
			break;
		case 405:
			ElMessage.error("The request method is wrong! Please try again later");
			break;
		case 408:
			ElMessage.error("The request timed out! Please try again later");
			break;
		case 500:
			ElMessage.error("Service exception!");
			break;
		case 502:
			ElMessage.error("Gateway error!");
			break;
		case 503:
			ElMessage.error("The service is unavailable!");
			break;
		case 504:
			ElMessage.error("Gateway timed out!");
			break;
		default:
			ElMessage.error("The request failed!");
	}
};
